var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.759.308A7.84 7.84 0 0 0 .913 8.153 7.84 7.84 0 0 0 8.76 16a7.84 7.84 0 0 0 7.846-7.846c.01-4.336-3.51-7.845-7.846-7.845Zm4.727 11.824c-.346-1.006-1.274-2.47-3.699-2.414H7.731c-2.414-.056-3.342 1.408-3.7 2.414A6.24 6.24 0 0 1 2.59 8.153c0-3.397 2.771-6.169 6.169-6.169s6.169 2.772 6.169 6.17a6.07 6.07 0 0 1-1.442 3.978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.759 8.768c1.08 0 1.956-.926 1.956-2.068s-.876-2.067-1.956-2.067-1.956.926-1.956 2.067.876 2.068 1.956 2.068"
  }))));
};
export default SvgUser;